import { render, staticRenderFns } from "./CustomerServiceChat.vue?vue&type=template&id=06750c16&scoped=true"
import script from "./CustomerServiceChat.vue?vue&type=script&lang=js"
export * from "./CustomerServiceChat.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceChat.vue?vue&type=style&index=0&id=06750c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06750c16",
  null
  
)

export default component.exports